import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function CfgLeftCornerChartScan() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Scan:</div>
        <div className='middle-rule-part'>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[w<sub>i</sub>, i, 1]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>0 &le; i &lt; n</span></div>
    </div>)
}
